var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "black",
    fillOpacity: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1583 19.2596L20.85 22.5763M20.8417 13.4263L15.1583 16.743M25.5 12.168C25.5 13.5487 24.3807 14.668 23 14.668C21.6193 14.668 20.5 13.5487 20.5 12.168C20.5 10.7873 21.6193 9.66797 23 9.66797C24.3807 9.66797 25.5 10.7873 25.5 12.168ZM15.5 18.0013C15.5 19.382 14.3807 20.5013 13 20.5013C11.6193 20.5013 10.5 19.382 10.5 18.0013C10.5 16.6206 11.6193 15.5013 13 15.5013C14.3807 15.5013 15.5 16.6206 15.5 18.0013ZM25.5 23.8346C25.5 25.2153 24.3807 26.3346 23 26.3346C21.6193 26.3346 20.5 25.2153 20.5 23.8346C20.5 22.4539 21.6193 21.3346 23 21.3346C24.3807 21.3346 25.5 22.4539 25.5 23.8346Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareButton);
export default __webpack_public_path__ + "static/media/share-button.469e520772309ad29a97745d728eb47f.svg";
export { ForwardRef as ReactComponent };